import React from 'react';
import VehicleRegistrationDialog from '../common/VehicleRegistrationDialog';
import { PARTY_KIND } from '../../constants/partyKindLookupConstants';

const PlaceVehicleRegistrationDialog = ({ ptsPlaceID, ...props }) => (
  <VehicleRegistrationDialog {...props} parentId={ptsPlaceID} partyType={PARTY_KIND.PLACE} />
);

export default PlaceVehicleRegistrationDialog;
